/* ============================================================
   AI Components CSS Module
   Design system: dark theme, Syne display, system body font
   ============================================================ */

/* ---------- Shared / Layout ---------- */

.panelFull {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.panelFullBg {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #0F1424;
  border-radius: 24px;
  border: 1px solid rgba(0, 210, 106, 0.1);
  overflow: hidden;
  box-shadow:
    0 8px 40px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(0, 210, 106, 0.06),
    0 0 40px rgba(0, 210, 106, 0.03);
}

.shrink0 { flex-shrink: 0; }
.flex1    { flex: 1; min-width: 0; }
.minW0    { min-width: 0; }

/* ---------- Bot Avatar ---------- */

.botAvatarSm {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: rgba(123, 92, 250, 0.2);
  border: 1px solid rgba(123, 92, 250, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #A78BFA;
}

.botAvatarGreen {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: rgba(0, 210, 106, 0.2);
  border: 1px solid rgba(0, 210, 106, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00D26A;
}

.botAvatarGreenGradient {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: linear-gradient(to bottom right, #00D26A, #00B85C);
  box-shadow: 0 0 10px rgba(0, 210, 106, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.botAvatarLg {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(123, 92, 250, 0.15);
  border: 1px solid rgba(123, 92, 250, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #A78BFA;
}

.botAvatarLgGreen {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(0, 210, 106, 0.1);
  border: 1px solid rgba(0, 210, 106, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #00D26A;
}

.botIconMd {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: rgba(123, 92, 250, 0.12);
  border: 1px solid rgba(123, 92, 250, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: #7B5CFA;
}

/* ---------- Typing Indicator ---------- */

.typingRow {
  display: flex;
  gap: 10px;
}

.typingBubble {
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border-top-left-radius: 4px;
  padding: 12px 16px;
}

.typingDots {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 20px;
}

.typingDot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #A78BFA;
  animation: aiDotBounce 0.6s infinite alternate;
}

.typingDotGreen {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #00D26A;
  animation: aiDotBounce 0.6s infinite alternate;
}

@keyframes aiDotBounce {
  0% { transform: translateY(0); }
  100% { transform: translateY(-6px); }
}

/* ---------- Chat Panel Header ---------- */

.chatHeader {
  flex-shrink: 0;
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chatHeaderRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chatHeaderLabel {
  font-size: 11px;
  font-weight: 600;
  color: #555C72;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.newBtn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #555C72;
  padding: 4px 8px;
  border-radius: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
}

.newBtn:hover {
  color: #8B92A8;
  background: rgba(255, 255, 255, 0.04);
}

/* ---------- Messages Area ---------- */

.messagesArea {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.messagesAreaLg {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

/* ---------- Empty State ---------- */

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 32px 24px;
}

.emptyTitle {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.emptyBody {
  font-size: 12px;
  color: #555C72;
  line-height: 1.6;
  max-width: 200px;
}

/* ---------- Message Bubbles ---------- */

.userBubbleRow {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.userBubble {
  background: #7B5CFA;
  border-radius: 16px;
  border-top-right-radius: 4px;
  padding: 12px 16px;
  max-width: 80%;
}

.userBubbleGreen {
  background: #00D26A;
  color: #0A0E1A;
  font-weight: 500;
  border-radius: 16px;
  border-top-right-radius: 4px;
  padding: 10px 16px;
  max-width: 85%;
}

.userBubbleText {
  font-size: 14px;
  color: #fff;
  line-height: 1.6;
}

.aiBubbleRow {
  display: flex;
  gap: 10px;
}

.aiBubble {
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 16px;
  border-top-left-radius: 4px;
  padding: 12px 16px;
}

.aiBubbleGreenBorder {
  background: #0D1020;
  border: 1px solid rgba(0, 210, 106, 0.1);
  border-radius: 16px;
  border-top-left-radius: 4px;
  padding: 12px 16px;
  max-width: 90%;
}

.aiBubbleText {
  font-size: 14px;
  color: #CBD5E1;
  line-height: 1.6;
}

.bubbleTimestamp {
  font-size: 11px;
  color: #555C72;
  opacity: 0;
  transition: opacity 0.15s;
}

.messageGroup:hover .bubbleTimestamp {
  opacity: 1;
}

.copyBtn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #555C72;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0;
  transition: color 0.15s, opacity 0.15s;
}

.messageGroup:hover .copyBtn {
  opacity: 1;
}

.copyBtn:hover {
  color: #8B92A8;
}

.bubbleMeta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.bubbleMetaRight {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  justify-content: flex-end;
}

.bubbleMetaLeft {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  justify-content: flex-start;
}

/* MessageBubble specific */

.messageBubbleWrap {
  display: flex;
  gap: 8px;
  max-width: 85%;
  animation: fadeIn 0.2s ease;
}

.messageBubbleWrapUser {
  composes: messageBubbleWrap;
  margin-left: auto;
  flex-direction: row-reverse;
}

.messageBubbleWrapAI {
  composes: messageBubbleWrap;
  margin-right: auto;
}

.mbUserAvatar {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
  color: #8B92A8;
}

.mbAiAvatar {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: rgba(123, 92, 250, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
  color: #A78BFA;
}

.mbContent {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mbBubbleUser {
  border-radius: 16px;
  padding: 10px 16px;
  background: #7B5CFA;
  color: #fff;
}

.mbBubbleAI {
  border-radius: 16px;
  padding: 10px 16px;
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.04);
  color: #fff;
}

.mbBubbleInner {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ---------- Markdown Rendering ---------- */

.mdH2 {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-top: 12px;
  margin-bottom: 4px;
}

.mdH3 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-top: 12px;
  margin-bottom: 4px;
}

.mdBold {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.mdParagraph {
  font-size: 14px;
  color: #CBD5E1;
  line-height: 1.6;
}

.mdUl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 8px 0;
}

.mdLi {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #CBD5E1;
}

.mdLiDot {
  flex-shrink: 0;
  margin-top: 6px;
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #A78BFA;
}

.mdOl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 8px 0;
  list-style: decimal inside;
}

.mdOlLi {
  font-size: 14px;
  color: #CBD5E1;
}

.mdSpacer {
  height: 4px;
}

/* ---------- Input Area ---------- */

.inputWrap {
  flex-shrink: 0;
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.inputWrapGreen {
  flex-shrink: 0;
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 210, 106, 0.12);
  background: #0A0E1A;
}

.inputBox {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: #131830;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  padding: 8px 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.inputBox:focus-within {
  border-color: rgba(123, 92, 250, 0.5);
}

.inputBoxGreen {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: #0F1424;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 8px 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.inputBoxGreen:focus-within {
  border-color: rgba(0, 210, 106, 0.5);
}

.inputBoxGreenHome {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: #0D1020;
  border: 1px solid rgba(0, 210, 106, 0.15);
  border-radius: 12px;
  padding: 8px 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.inputBoxGreenHome:focus-within {
  border-color: rgba(0, 210, 106, 0.4);
  box-shadow: 0 0 15px rgba(0, 210, 106, 0.1);
}

.textarea {
  flex: 1;
  background: transparent;
  font-size: 14px;
  color: #fff;
  resize: none;
  outline: none;
  min-height: 20px;
  max-height: 128px;
  border: none;
  font-family: inherit;
  line-height: 1.4;
}

.textarea:focus-visible {
  outline: none;
}

.textarea::placeholder {
  color: #555C72;
}

.textareaDisabled {
  composes: textarea;
  opacity: 0.5;
}

.sendBtn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}

.sendBtnActive {
  composes: sendBtn;
  background: #7B5CFA;
  color: #fff;
}

.sendBtnActive:hover {
  background: #6D4AE6;
}

.sendBtnActive:active {
  transform: scale(0.95);
}

.sendBtnActiveGreen {
  composes: sendBtn;
  background: #00D26A;
  color: #0A0E1A;
}

.sendBtnActiveGreen:hover {
  background: #00bb5f;
}

.sendBtnActiveGreen:active {
  transform: scale(0.95);
}

.sendBtnDisabled {
  composes: sendBtn;
  background: rgba(255, 255, 255, 0.05);
  color: #555C72;
  cursor: not-allowed;
}

.inputHint {
  font-size: 11px;
  color: #555C72;
  text-align: center;
  margin-top: 6px;
}

/* ---------- Error Banner ---------- */

.errorBanner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 12px;
  padding: 12px;
}

.errorText {
  font-size: 12px;
  color: #EF4444;
}

/* ---------- Tier Gate ---------- */

.tierGate {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
}

.tierGateTitle {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.tierGateBody {
  font-size: 12px;
  color: #555C72;
  margin-bottom: 16px;
}

.tierGateBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  background: #00D26A;
  color: #0A0E1A;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}

.tierGateBtn:hover {
  background: #00bb5f;
}

.tierGateBtn:active {
  transform: scale(0.95);
}

/* ---------- Tool Selector ---------- */

.toolSelectorWrap {
  position: relative;
}

.toolSelectorBtn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s;
  color: #fff;
}

.toolSelectorBtn:hover {
  border-color: rgba(123, 92, 250, 0.5);
}

.toolSelectorBtnOpen {
  composes: toolSelectorBtn;
  border-color: rgba(123, 92, 250, 0.5);
  background: #0D1020;
}

.toolSelectorIcon {
  color: #A78BFA;
  flex-shrink: 0;
}

.toolSelectorLabel {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toolSelectorChevron {
  color: #555C72;
  flex-shrink: 0;
  transition: transform 0.15s;
}

.toolSelectorChevronOpen {
  composes: toolSelectorChevron;
  transform: rotate(180deg);
}

.toolDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #131830;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
  z-index: 50;
  overflow: hidden;
  padding: 4px 0;
  max-height: 360px;
  overflow-y: auto;
}

.toolGroupLabel {
  padding: 8px 12px;
  position: sticky;
  top: 0;
  background: rgba(19, 24, 48, 0.95);
  font-size: 10px;
  font-weight: 600;
  color: #555C72;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.toolItem {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.15s;
  color: #fff;
}

.toolItem:hover {
  background: rgba(255, 255, 255, 0.04);
}

.toolItemActive {
  composes: toolItem;
  background: rgba(123, 92, 250, 0.1);
}

.toolItemLocked {
  composes: toolItem;
  opacity: 0.4;
  cursor: not-allowed;
}

.toolItemIcon {
  flex-shrink: 0;
  color: #555C72;
}

.toolItemIconActive {
  flex-shrink: 0;
  color: #A78BFA;
}

.toolItemName {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.toolItemNameActive {
  font-size: 14px;
  font-weight: 500;
  color: #C4B5FD;
}

.toolItemDesc {
  font-size: 12px;
  color: #555C72;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toolItemLockBadge {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-size: 11px;
  color: #555C72;
  text-transform: capitalize;
}

.toolItemActiveDot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #7B5CFA;
  flex-shrink: 0;
}

/* ---------- Context Indicator ---------- */

.contextRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  font-size: 12px;
  transition: all 0.15s;
}

.contextRowActive {
  composes: contextRow;
  background: rgba(123, 92, 250, 0.08);
  border-color: rgba(123, 92, 250, 0.2);
  color: #C4B5FD;
}

.contextRowInactive {
  composes: contextRow;
  background: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.04);
  color: #555C72;
}

.contextIconWrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 9999px;
}

.contextIconActive {
  composes: contextIconWrap;
  background: rgba(123, 92, 250, 0.2);
}

.contextIconInactive {
  composes: contextIconWrap;
  background: rgba(255, 255, 255, 0.04);
}

.contextText {
  flex: 1;
  min-width: 0;
}

.contextTextBold {
  font-weight: 500;
  margin-right: 4px;
}

.contextDot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #A78BFA;
  flex-shrink: 0;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* ---------- Confirmation Card ---------- */

.confirmCard {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 320px;
}

.confirmLabel {
  font-size: 10px;
  font-weight: 600;
  color: #555C72;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.confirmAction {
  font-size: 14px;
  color: #fff;
  line-height: 1.4;
}

.confirmPreview {
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 6px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.confirmPreviewKey {
  font-size: 12px;
  color: #555C72;
  flex-shrink: 0;
  text-transform: capitalize;
}

.confirmPreviewVal {
  font-size: 12px;
  color: #CBD5E1;
  word-break: break-all;
}

.confirmError {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #EF4444;
}

.confirmActions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.confirmBtn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}

.confirmBtnConfirm {
  composes: confirmBtn;
  background: #7B5CFA;
  color: #fff;
}

.confirmBtnConfirm:hover {
  background: #6D4AE6;
}

.confirmBtnConfirm:active {
  transform: scale(0.95);
}

.confirmBtnConfirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.confirmBtnCancel {
  composes: confirmBtn;
  background: transparent;
  color: #CBD5E1;
}

.confirmBtnCancel:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
}

.confirmBtnCancel:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.confirmResolved {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
}

.confirmResolvedOk {
  composes: confirmResolved;
  color: #00D26A;
}

.confirmResolvedCancel {
  composes: confirmResolved;
  color: #555C72;
}

/* ---------- Daily Briefing ---------- */

.briefingHeader {
  display: flex;
  align-items: center;
  gap: 8px;
}

.briefingHeaderText {
  font-size: 15px;
  font-weight: 500;
  color: #fff;
}

.briefingCard {
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  padding: 20px;
}

.briefingSectionHead {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-top: 12px;
}

.briefingSectionHead:first-child {
  margin-top: 0;
}

.briefingBullet {
  font-size: 14px;
  color: #CBD5E1;
  padding-left: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.briefingBulletDot {
  color: #A78BFA;
  margin-top: 4px;
}

.briefingText {
  font-size: 14px;
  color: #CBD5E1;
}

.briefingActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.briefingActionBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: none;
  border-radius: 9999px;
  font-size: 14px;
  color: #CBD5E1;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.briefingActionBtn:hover {
  background: rgba(123, 92, 250, 0.15);
  color: #A78BFA;
}

/* Shimmer for loading state */

.shimmerBlock {
  height: 14px;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ---------- Dashboard Widgets ---------- */

.widgetsWrap {
  overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #0F1424;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow:
    0 8px 40px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.03);
}

.widgetsStickyHeader {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(15, 20, 36, 0.95);
  border-radius: 24px 24px 0 0;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.widgetsHeaderLabel {
  font-family: 'Syne', sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #444B5F;
}

.widgetsHeaderLink {
  font-size: 10px;
  color: #555C72;
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.15s;
}

.widgetsHeaderLink:hover {
  color: #00D26A;
}

.widgetsBody {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
}

.widgetsBody > :last-child {
  margin-top: auto;
}

.widgetCard {
  border-radius: 12px;
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 16px;
}

.revenueCard {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  background: linear-gradient(to bottom right, #110D1F, #0D0A18);
  border: 1px solid rgba(123, 92, 250, 0.15);
  padding: 20px;
}

.revenueCardGlow {
  position: absolute;
  top: 0;
  right: 0;
  width: 128px;
  height: 128px;
  background: rgba(123, 92, 250, 0.08);
  border-radius: 9999px;
  transform: translate(50%, -50%);
  filter: blur(24px);
}

.widgetIconWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
}

.widgetIconWrapSm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
}

.widgetMiniLabel {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: #444B5F;
}

.widgetBigNumber {
  font-family: 'Syne', sans-serif;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}

.widgetSmallText {
  font-size: 10px;
  color: #555C72;
}

.widgetTwoCol {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.overdueCard {
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.15);
  background: #1A0D0D;
  padding: 16px;
}

.pipelineBar {
  display: flex;
  border-radius: 9999px;
  overflow: hidden;
  height: 16px;
  width: 100%;
  gap: 2px;
  margin-bottom: 12px;
}

.pipelineBarSeg {
  border-radius: 9999px;
  transition: width 0.5s ease;
}

.pipelineLegend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pipelineLegendItem {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pipelineLegendDot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
}

.pipelineLegendText {
  font-size: 10px;
  color: #8B92A8;
}

.goalBar {
  width: 100%;
  height: 12px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 9999px;
  overflow: hidden;
}

.goalBarFill {
  height: 100%;
  border-radius: 9999px;
  background: linear-gradient(to right, #00D26A, #00E676);
  transition: width 0.7s ease;
  box-shadow: 0 0 10px rgba(0, 210, 106, 0.3);
}

.goalRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.sparklineWrap {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 40px;
}

.sparklineBar {
  width: 8px;
  border-radius: 9999px;
  transition: height 0.5s ease;
}

.quickActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.quickActionBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(0, 210, 106, 0.08);
  color: #00D26A;
  border: 1px solid rgba(0, 210, 106, 0.15);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.1s;
}

.quickActionBtn:hover {
  background: rgba(0, 210, 106, 0.15);
  border-color: rgba(0, 210, 106, 0.3);
  box-shadow: 0 0 15px rgba(0, 210, 106, 0.1);
}

.quickActionBtn:active {
  transform: scale(0.95);
}

/* ---------- Data Display Card ---------- */

.dataCard {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  max-width: 100%;
}

.dataCardLabel {
  font-size: 10px;
  font-weight: 600;
  color: #555C72;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}

.dataTable {
  width: 100%;
  font-size: 12px;
}

.dataTh {
  text-align: left;
  color: #555C72;
  font-weight: 500;
  padding-bottom: 6px;
  padding-right: 12px;
}

.dataThRight {
  composes: dataTh;
  text-align: right;
}

.dataTd {
  padding: 6px 12px 6px 0;
  color: #fff;
  font-weight: 500;
}

.dataTdSecondary {
  padding: 6px 12px 6px 0;
  color: #CBD5E1;
}

.dataTdRight {
  padding: 6px 12px 6px 0;
  text-align: right;
  color: #fff;
}

.dataTdTertiary {
  padding: 6px 0;
  color: #555C72;
}

.dataTr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.dataTr:last-child {
  border-bottom: none;
}

.dataStatusBadge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.04);
  color: #CBD5E1;
  text-transform: capitalize;
}

.dataStatusOverdue {
  composes: dataStatusBadge;
  background: rgba(239, 68, 68, 0.15);
  color: #EF4444;
}

.dataStatusPaid {
  composes: dataStatusBadge;
  background: rgba(0, 210, 106, 0.15);
  color: #00D26A;
}

.dataAnalyticsGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.dataAnalyticsCell {
  background: #0D1020;
  border-radius: 6px;
  padding: 8px 10px;
}

.dataAnalyticsCellLabel {
  font-size: 10px;
  color: #555C72;
  text-transform: capitalize;
  margin-bottom: 2px;
}

.dataAnalyticsCellVal {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.dataBrandRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.dataBrandRow:last-child {
  border-bottom: none;
}

.dataBrandName {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dataBrandIndustry {
  font-size: 10px;
  color: #555C72;
  text-transform: capitalize;
}

.dataRecordLabel {
  font-size: 10px;
  font-weight: 600;
  color: #555C72;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}

.dataRecordRow {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.dataRecordKey {
  font-size: 12px;
  color: #555C72;
  flex-shrink: 0;
  text-transform: capitalize;
  min-width: 80px;
}

.dataRecordVal {
  font-size: 12px;
  color: #fff;
  word-break: break-all;
}

.dataPre {
  font-size: 12px;
  color: #CBD5E1;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: monospace;
  line-height: 1.6;
}

.dataEmpty {
  font-size: 12px;
  color: #555C72;
  font-style: italic;
}

.dataRelScore {
  font-size: 12px;
  font-weight: 600;
  color: #A78BFA;
}

.dataRelLabel {
  font-size: 10px;
  color: #555C72;
}

/* ---------- Deal Review Result ---------- */

.recBanner {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  padding: 16px;
}

.recLabel {
  font-size: 18px;
  font-weight: 700;
}

.recDesc {
  font-size: 14px;
  color: #CBD5E1;
  margin-top: 2px;
}

.scoreCircleWrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 112px;
}

.scoreCircleSvg {
  width: 112px;
  height: 112px;
  transform: rotate(-90deg);
}

.scoreCircleBg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.06);
  stroke-width: 8;
}

.scoreCircleFg {
  fill: none;
  stroke-width: 8;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.7s ease;
}

.scoreCircleInner {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.scoreCircleNumber {
  font-size: 30px;
  font-weight: 700;
}

.scoreCircleSuffix {
  font-size: 12px;
  color: #555C72;
}

.breakdownRow {
  margin-bottom: 12px;
}

.breakdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.breakdownLabel {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #CBD5E1;
}

.breakdownMax {
  font-size: 12px;
  color: #555C72;
}

.breakdownScore {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.listItem {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #CBD5E1;
}

.listItemIcon {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 10px;
}

.listItemIconGreen {
  composes: listItemIcon;
  background: rgba(0, 210, 106, 0.15);
  color: #00D26A;
}

.listItemIconWarning {
  composes: listItemIcon;
  background: rgba(251, 146, 60, 0.15);
  color: #FB923C;
}

/* ---------- Floating AI Button ---------- */

.floatingWrap {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 40;
}

.floatingBtn {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 40%, #7B5CFA 100%);
  color: #fff;
  font-family: 'Syne', sans-serif;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  box-shadow:
    0 8px 32px rgba(0, 210, 106, 0.3),
    0 0 0 1px rgba(0, 210, 106, 0.15);
  transition: all 0.2s ease;
}

.floatingBtn:hover {
  transform: scale(1.08);
  box-shadow:
    0 12px 40px rgba(0, 210, 106, 0.4),
    0 0 0 1px rgba(0, 210, 106, 0.25);
}

.floatingBtn:active {
  transform: scale(0.95);
}

.floatingBtnOpen {
  composes: floatingBtn;
  opacity: 0.85;
}

/* ---------- Slide Panel ---------- */

.slidePanelBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(5, 7, 15, 0.7);
  backdrop-filter: blur(4px);
  z-index: 40;
}

.slidePanel {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 50;
  width: min(420px, calc(100vw - 32px));
  height: min(700px, calc(100vh - 32px));
  background: #0F1424;
  border: 1px solid rgba(0, 210, 106, 0.1);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow:
    0 32px 100px rgba(0, 0, 0, 0.7),
    0 0 0 1px rgba(0, 210, 106, 0.06),
    0 0 80px rgba(0, 210, 106, 0.05),
    0 0 40px rgba(123, 92, 250, 0.04);
  animation: slideInUp 0.25s ease-out;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

@media (max-width: 480px) {
  .slidePanel {
    bottom: 0;
    right: 0;
    width: 100%;
    height: 92vh;
    border-radius: 24px 24px 0 0;
  }
}

@keyframes slideInUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Gradient header — matches signup panel */
.slidePanelHeader {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 40%, #7B5CFA 100%);
}

.slidePanelHeaderLeft {
  display: flex;
  align-items: center;
  gap: 10px;
}

.slidePanelAvatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.slidePanelTitle {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.slidePanelStatus {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 2px;
}

.slidePanelStatusDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
  animation: slidePulse 2s ease-in-out infinite;
}

@keyframes slidePulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.slidePanelStatusText {
  color: rgba(255, 255, 255, 0.85);
  font-size: 11.5px;
  font-weight: 500;
}

.slidePanelUsage {
  margin-left: 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
}

.slidePanelActions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.slidePanelCloseBtn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.15s ease;
}

.slidePanelCloseBtn:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.slidePanelContext {
  flex-shrink: 0;
  padding: 8px 18px;
  background: rgba(0, 210, 106, 0.04);
  border-bottom: 1px solid rgba(0, 210, 106, 0.1);
  font-size: 12px;
  color: #00D26A;
  display: flex;
  align-items: center;
  gap: 6px;
}

.limitBanner {
  flex-shrink: 0;
  margin: 0 16px 8px;
  padding: 10px 14px;
  background: rgba(251, 146, 60, 0.08);
  border: 1px solid rgba(251, 146, 60, 0.2);
  border-radius: 12px;
}

.limitBannerText {
  font-size: 12px;
  color: #FB923C;
}

.newConvoBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.03);
  color: #8B92A8;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.15s ease;
}

.newConvoBtn:hover {
  background: rgba(0, 210, 106, 0.06);
  border-color: rgba(0, 210, 106, 0.2);
  color: #00D26A;
}

/* ---------- Home Chat Panel ---------- */

.homeHeader {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 40%, #7B5CFA 100%);
}

.homeHeaderLeft {
  display: flex;
  align-items: center;
  gap: 10px;
}

.homeHeaderAvatar {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.homeHeaderOnline {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: #fff;
  border: 2px solid #14B8A6;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
}

.homeHeaderTitle {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.homeHeaderSub {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 2px;
  font-weight: 500;
}

.homeEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  text-align: center;
  padding: 32px 0 8px;
}

.homeEmptyAvatar {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(to bottom right, #00D26A, #00B85C);
  box-shadow: 0 0 30px rgba(0, 210, 106, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #fff;
}

.homeEmptyGreeting {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.homeEmptyBody {
  font-size: 14px;
  color: #8B92A8;
}

.homeSuggestedWrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.homeSuggestedBtn {
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgba(0, 210, 106, 0.2);
  background: rgba(0, 210, 106, 0.08);
  color: #66E8A8;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s, box-shadow 0.15s, transform 0.1s;
}

.homeSuggestedBtn:hover {
  border-color: rgba(0, 210, 106, 0.5);
  color: #fff;
  background: rgba(0, 210, 106, 0.15);
  box-shadow: 0 0 12px rgba(0, 210, 106, 0.15);
}

.homeSuggestedBtn:active {
  transform: scale(0.95);
}

.homeUsageText {
  font-size: 10px;
  color: #555C72;
}

.homeLimitBanner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(251, 146, 60, 0.1);
  border: 1px solid rgba(251, 146, 60, 0.2);
  border-radius: 12px;
  padding: 12px 16px;
}

.homeLimitText {
  font-size: 12px;
  color: #FB923C;
  flex: 1;
}

/* ---------- Mid-Session Alert ---------- */

.alertCard {
  border: 1px solid;
  border-radius: 8px;
  padding: 12px;
  animation: fadeIn 0.2s ease;
}

.alertInner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.alertIcon {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

.alertContent {
  flex: 1;
  min-width: 0;
}

.alertTitle {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.alertBody {
  font-size: 12px;
  color: #CBD5E1;
  margin-top: 2px;
}

.alertActionBtn {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #A78BFA;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}

.alertActionBtn:hover {
  color: #C4B5FD;
}

.alertDismissBtn {
  flex-shrink: 0;
  color: #555C72;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.15s;
}

.alertDismissBtn:hover {
  color: #8B92A8;
}

/* ---------- Suggested Actions (slide panel) ---------- */

.suggestedWrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.suggestedBtn {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 9999px;
  padding: 6px 12px;
  font-size: 14px;
  color: #CBD5E1;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s, transform 0.1s;
}

.suggestedBtn:hover {
  background: rgba(123, 92, 250, 0.15);
  color: #A78BFA;
  border-color: rgba(123, 92, 250, 0.3);
}

.suggestedBtn:active {
  transform: scale(0.95);
}

/* ---------- Suggested Prompts (chat panel) ---------- */

.promptsWrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.promptBtn {
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: rgba(255, 255, 255, 0.04);
  color: #CBD5E1;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s, transform 0.1s;
}

.promptBtn:hover {
  border-color: rgba(123, 92, 250, 0.5);
  color: #C4B5FD;
  background: rgba(123, 92, 250, 0.08);
}

.promptBtn:active {
  transform: scale(0.95);
}

/* ---------- Utility ---------- */

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- Responsive ---------- */

@media (max-width: 768px) {
  .widgetTwoCol {
    grid-template-columns: 1fr;
  }
}
